export default __webpack_public_path__ + "static/media/ROM EXAM PATTERN 2026-27 (CLASS - 9).744654df.pdf";